import React, { PropsWithChildren, ReactNode } from 'react';

export interface ConditionalWrapperProps {
  condition: boolean;
  wrapper: (children: ReactNode) => JSX.Element;
}

/**
 * A component which can be used to conditionally render a wrapper (e.g. a Tooltip around a component). This is useful
 * to avoid having to duplicate code inside a ternary operator.
 */
export const ConditionalWrapper: React.FC<PropsWithChildren<ConditionalWrapperProps>> = ({
  condition,
  wrapper,
  children,
}) => (condition ? wrapper(children) : <>{children}</>);
